import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const ImgDescContaineriews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
  margin-bottom: 20px;

    h3 {
      font-size: 22px;
      border-left: 5px solid;
      padding-left: 14px;
    }
  `,
  tablet: css`
    h3 {
      font-size: 36px;
      border-left: 5px solid;
      padding-left: 14px;
    }
  `,
  tabletLandscape: css`
    h3 {
      font-size: 36px;
      border-left: 5px solid;
      padding-left: 14px;
    }
  `,
  browser: css`
    h3 {
      font-size: 44px;
      border-left: 5px solid;
      padding-left: 14px;
    }
  `,
};

export const ImgDescContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;

  img {
    width: 300px;
    margin-bottom: 5%;
  }
  h3 {
    color: ${({ theme }) => theme.colors.nrmaBlue};
  }
  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return ImgDescContaineriews["mobile"];
      case "tablet":
        return props.isLandscape
          ? ImgDescContaineriews["tabletLandscape"]
          : ImgDescContaineriews["tablet"];

      case "browser":
        return ImgDescContaineriews["browser"];
    }
  }}
`;
